import validate from './validate.js'
export default {
	mobile: [
		{required: true, message: '请输入手机号码', trigger: 'blur'},
		{validator: validate.validatemphone, trigger: 'blur'},
	],
	enterpriseName: [
		{required: true, message: '请输入企业全称', trigger: 'blur'},
		{validator: validate.enterpriseName, trigger: 'blur'},
		{ validator: validate.max100, trigger: 'blur' }
	],
	username: [
		{required: true, message: '请输入手机号码', trigger: 'blur'},
		{validator: validate.validatemphone, trigger: 'blur'},
	],
	code: [
		{required: true, message: '请输入手机验证码', trigger: 'blur'},
		{validator: validate.validatemcode, trigger: 'blur' }
	],
	password: [
		{required: true, message: '请设置密码', trigger: 'blur'},
		{validator: validate.validatempassword, trigger: 'blur' }
	],
	password2: [
		{required: true, message: '请输入密码', trigger: 'blur'},
	],

}
